import { FeatureFlags } from '@/types/featureFlags';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/performance-value',
    name: 'PvmDashboard',
    component: () => import('@/views/PvmDashboard.vue'),
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pagePvmDashboard.metaTitle',
      requiredLDFlags: [FeatureFlags.PVM_DASHBOARD_ENABLED],
    },
  },
];
export default routes;
